var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.interview)?_c('process-interview-scene',{attrs:{"loading":_vm.loading,"interview":_vm.interview,"vacancy":_vm.vacancy,"from-registration":_vm.fromRegistration,"error":_vm.error,"fetch":_vm.fetch}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }